import LayoutBasic from '@/components/LayoutBasic/LayoutBasic.vue'
import { JSConn } from '@/utilities/js-conn.js'
import { TOAST_DURATION } from '@/constants'

export default {
  name: 'OtherIncomeEditForm',
  components: {
    LayoutBasic
  },
  props: ['id'],
  data () {
    return {
      otherIncomeEditItem: null,
      mode: 'edit'
    }
  },
  created () {
    if (this.id === 'new') {
      this.mode = 'new'
      this.otherIncomeEditItem = {
        description: null,
        price: null,
        defaultQuantity: 1
      }
    } else {
      this.mode = 'edit'
      const item = this.$store.getters.getOtherIncomeItemById(this.id)
      // just want a local copy for the form
      this.otherIncomeEditItem = {...item}
    }
  },
  methods: {
    submitForm (evt) {
      evt.preventDefault()
      const jsConn = new JSConn()
      jsConn.toRoutePath = '/other-income'

      jsConn.formParams = {
        id: this.id,
        item: this.otherIncomeEditItem
      }

      this.$store.dispatch('updateOtherIncomeItem', jsConn)
        .then((jsConn) => {
          this.$toast.open({
            message: jsConn.toastMessage,
            type: 'is-success',
            duration: TOAST_DURATION
          })
          this.$router.push(jsConn.toRoutePath)
        })
        .catch((jsConn) => {
          this.$toast.open({
            message: jsConn.toastMessage,
            type: 'is-danger',
            duration: TOAST_DURATION
          })
        })
    }
  }
}
